import { createRootRouteWithContext } from '@tanstack/react-router';
import { RootComponent } from '@Router/RootComponent';
import { loadExperiencesQuery } from '@Services/convert/useExperience';
import { setExperienceProperties } from '@Services/analytics/tracking.service';
import { SplashScreen } from '@Components/splash/SplashScreen';
import type { QueryClient } from '@tanstack/react-query';

export const rootRoute = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: () => <RootComponent />,
  loader: async ({ context }) => {
    const experiences = await context.queryClient.ensureQueryData(loadExperiencesQuery);
    setExperienceProperties(experiences);
  },
  pendingComponent: () => <SplashScreen />,
  wrapInSuspense: true,
});
